export enum ROLE_ENUM {
  ADMIN = 1,
  SUPER_ADMIN = 9999,
}
